import React from "react";

const DateIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M6 9.33325C6 9.70144 5.70152 9.99992 5.33333 9.99992C4.96514 9.99992 4.66667 9.70144 4.66667 9.33325C4.66667 8.96506 4.96514 8.66659 5.33333 8.66659C5.70152 8.66659 6 8.96506 6 9.33325Z"
        fill="#070B12"
      />
      <path
        d="M5.33333 12.6666C5.70152 12.6666 6 12.3681 6 11.9999C6 11.6317 5.70152 11.3333 5.33333 11.3333C4.96514 11.3333 4.66667 11.6317 4.66667 11.9999C4.66667 12.3681 4.96514 12.6666 5.33333 12.6666Z"
        fill="#070B12"
      />
      <path
        d="M8.66667 9.33325C8.66667 9.70144 8.36819 9.99992 8 9.99992C7.63181 9.99992 7.33333 9.70144 7.33333 9.33325C7.33333 8.96506 7.63181 8.66659 8 8.66659C8.36819 8.66659 8.66667 8.96506 8.66667 9.33325Z"
        fill="#070B12"
      />
      <path
        d="M8 12.6666C8.36819 12.6666 8.66667 12.3681 8.66667 11.9999C8.66667 11.6317 8.36819 11.3333 8 11.3333C7.63181 11.3333 7.33333 11.6317 7.33333 11.9999C7.33333 12.3681 7.63181 12.6666 8 12.6666Z"
        fill="#070B12"
      />
      <path
        d="M11.3333 9.33325C11.3333 9.70144 11.0349 9.99992 10.6667 9.99992C10.2985 9.99992 10 9.70144 10 9.33325C10 8.96506 10.2985 8.66659 10.6667 8.66659C11.0349 8.66659 11.3333 8.96506 11.3333 9.33325Z"
        fill="#070B12"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3333 1.99992C11.3333 1.63173 11.0349 1.33325 10.6667 1.33325C10.2985 1.33325 10 1.63173 10 1.99992V3.33325L6 3.33325V1.99992C6 1.63173 5.70152 1.33325 5.33333 1.33325C4.96514 1.33325 4.66667 1.63173 4.66667 1.99992V3.33325L4 3.33325C2.89543 3.33325 2 4.22868 2 5.33325V12.6666C2 13.7712 2.89543 14.6666 4 14.6666H12C13.1046 14.6666 14 13.7712 14 12.6666V5.33325C14 4.22868 13.1046 3.33325 12 3.33325H11.3333V1.99992ZM4 4.66659C3.63181 4.66659 3.33333 4.96506 3.33333 5.33325V6.49992H12.6667V5.33325C12.6667 4.96506 12.3682 4.66659 12 4.66659H4ZM12.6667 7.83325H3.33333V12.6666C3.33333 13.0348 3.63181 13.3333 4 13.3333H12C12.3682 13.3333 12.6667 13.0348 12.6667 12.6666V7.83325Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default DateIcon;
